import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const PageFooter: React.FC = () => (
    <Box
        sx={{
            pt: { xs: 6, sm: 8, md: 10 },
            pb: { xs: 4, sm: 5 },
            px: { xs: 2, sm: 3, md: 4 },
            position: 'relative',
            zIndex: 2,
        }}
    >
        <Box sx={{ maxWidth: 1000, mx: 'auto' }}>
            {/* Acknowledgement of Country */}
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', sm: 'row' },
                    gap: { xs: 3, sm: 3, md: 4 },
                    alignItems: { xs: 'center', sm: 'flex-start' },
                    mb: { xs: 5, sm: 6 },
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        flexShrink: 0,
                        gap: 1,
                    }}
                >
                    <Box
                        component="img"
                        src="/acknowledgement-artwork.png"
                        alt="Indigenous artwork"
                        sx={{
                            width: { xs: 160, sm: 180, md: 200 },
                            height: { xs: 160, sm: 180, md: 200 },
                            objectFit: 'contain',
                        }}
                    />
                    <Typography
                        variant="caption"
                        sx={{
                            color: 'rgba(255,255,255,0.75)',
                            textAlign: 'center',
                            lineHeight: 1.4,
                            fontSize: '0.75rem',
                        }}
                    >
                        SBCC First Nations Artwork:
                        <br />
                        Jordan Lovegrove
                    </Typography>
                </Box>
                <Box
                    sx={{
                        color: 'rgba(255, 255, 255, 0.9)',
                        lineHeight: 1.6,
                        flex: 1,
                        textAlign: { xs: 'center', sm: 'left' },
                    }}
                >
                    <Typography
                        variant="overline"
                        sx={{
                            display: 'block',
                            mb: 1.5,
                            color: 'rgba(255, 255, 255, 1)',
                            letterSpacing: '0.15em',
                            fontWeight: 700,
                            fontSize: { xs: '0.85rem', sm: '0.9rem' },
                        }}
                    >
                        ACKNOWLEDGEMENT OF COUNTRY
                    </Typography>
                    <Typography
                        variant="body2"
                        paragraph
                        sx={{
                            color: 'rgba(255, 255, 255, 0.95)',
                            fontSize: { xs: '0.875rem', sm: '0.9rem' },
                            mb: 1.5,
                            lineHeight: 1.6,
                        }}
                    >
                        The State Bushfire Coordination Committee (SBCC)
                        acknowledges the First Nations peoples and Traditional
                        Owners of Country throughout South Australia.
                    </Typography>
                    <Typography
                        variant="body2"
                        sx={{
                            color: 'rgba(255, 255, 255, 0.95)',
                            fontSize: { xs: '0.875rem', sm: '0.9rem' },
                            lineHeight: 1.6,
                        }}
                    >
                        We recognise their diverse and enduring culture and deep
                        spiritual connection to the lands, skies, and waters of
                        SA and extend our respect to all Aboriginal and Zenadth
                        Kes peoples', and their Elders past and present.
                    </Typography>
                </Box>
            </Box>

            {/* NEMA funding */}
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', sm: 'row' },
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: { xs: 2, sm: 3 },
                    pt: { xs: 4, sm: 5 },
                    borderTop: '1px solid rgba(255, 255, 255, 0.2)',
                }}
            >
                <Box
                    component="img"
                    src="/nema-logo-white.png"
                    alt="National Emergency Management Agency"
                    sx={{
                        height: { xs: 40, sm: 50, md: 60 },
                        width: 'auto',
                        objectFit: 'contain',
                    }}
                />
                <Typography
                    variant="body2"
                    sx={{
                        color: 'rgba(255, 255, 255, 0.95)',
                        fontSize: { xs: '0.875rem', sm: '0.9rem' },
                        textAlign: 'center',
                        lineHeight: 1.6,
                    }}
                >
                    Supported by the Australian Government's National Emergency
                    Management Agency.
                </Typography>
            </Box>
        </Box>
    </Box>
);

export default PageFooter;
